<div class="row earnings-limitation nova-font-style">
  <div class="col s12 m10 offset-m1 l8 offset-l2 xl6 offset-xl3 remove-default-padding">
    <h2>Earnings Limitation</h2>
    <div>
      <kendo-tabstrip [animate]="true" [tabAlignment]="'justify'">
        <kendo-tabstrip-tab title="Wages" [selected]="true">
          <ng-template kendoTabContent>
            <app-wage-file></app-wage-file>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="Exemptions">
          <ng-template kendoTabContent>
            <app-exemptions></app-exemptions>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="History">
          <ng-template kendoTabContent>
            <app-upload-history [fileType]="'Wages'"></app-upload-history>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
  </div>
</div>
